import { useReducer } from 'react'

export const initialModalState = {
  queue: []
}

const actionTypes = {
  closeAll: 'CLOSEALL',
  open: 'OPEN',
  close: 'CLOSE',
}

export const modalReducer = (state, action) => {
  const { queue } = state
  switch (action.type) {
    case actionTypes.closeAll:
      return {
        ...state,
        queue: []
      }
    case actionTypes.open: {
      const modalExists = queue.some(event => event.key === action.payload.key)
      if (modalExists) {
        return state
      } else {
        queue.push({ ...action.payload })
        return {
          ...state,
          queue
        }
      }
    }
    case actionTypes.close:
      queue.push({ ...action.payload })
      return {
        ...state,
        queue
      }
    default:
      return state
  }
}

const useModal = () => {
  const [{ queue }, dispatch] = useReducer(modalReducer, initialModalState)

  const setOpen = modalSettings => {
    dispatch({
      type: actionTypes.open,
      payload: modalSettings
    })
  }
  const setClose = () => dispatch({ type: actionTypes.close })
  const setCloseAll = () => dispatch({ type: actionTypes.closeAll, payload: '' })

  return { queue, setOpen, setClose, setCloseAll }
}

export default useModal
